import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

function AuthPromptModal({ children }) {
  const { isAuthenticated } = useAuth()
  const [showAuthModal, setShowAuthModal] = useState(false)
  const navigate = useNavigate()

  const renderModal = () => {
    if (!showAuthModal) {
      return
    }

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.3)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: 8,
            padding: 24,
            minWidth: 300,
            textAlign: 'center',
            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
          }}
        >
          <h2 style={{ fontSize: 20, marginBottom: 16 }}>Login Required</h2>
          <p style={{ marginBottom: 24 }}>Please login or sign up to access this feature.</p>
          <button
            onClick={() => {
              navigate('/login')
              setShowAuthModal(false)
            }}
            style={{
              marginRight: 12,
              background: '#055299',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              fontWeight: 500,
            }}
          >
            Login
          </button>
          <button
            onClick={() => {
              navigate('/signup')
              setShowAuthModal(false)
            }}
            style={{
              background: '#990556',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              fontWeight: 500,
            }}
          >
            Sign Up
          </button>
          <div>
            <button
              onClick={() => setShowAuthModal(false)}
              style={{
                marginTop: 16,
                color: '#888',
                background: 'none',
                border: 'none',
                fontSize: 16,
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (isAuthenticated()) {
    return children
  }

  return (
    <>
      <button
        onClick={() => setShowAuthModal(true)}
        className="border-0 bg-transparent p-0 m-0 text-decoration-none text-transform-none cursor-pointer flex flex-1 w-full [&>*]:pointer-events-none"
        aria-label="Authenticate to access"
      >
        {children}
      </button>
      {renderModal()}
    </>
  )
}

export default AuthPromptModal
